import { render, staticRenderFns } from "./guide_banner.vue?vue&type=template&id=2bcb477a&scoped=true&"
import script from "./guide_banner.vue?vue&type=script&lang=js&"
export * from "./guide_banner.vue?vue&type=script&lang=js&"
import style0 from "./guide_banner.vue?vue&type=style&index=0&id=2bcb477a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcb477a",
  null
  
)

export default component.exports